"use client";

import { useEffect, useState } from "react";

export const InfoBackgroudWrapper = ({ children } : any) => {
  const [deviceType, setDeviceType] = useState<"mobile" | "tablet" | "desktop">("desktop");

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setDeviceType("mobile");
      } else if (width < 1280) {
        setDeviceType("tablet");
      } else {
        setDeviceType("desktop");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const leftVectorSrc = 
    deviceType === "mobile" 
      ? "/assets/vectorLeftMobile.svg"
      : deviceType === "tablet"
        ? "/assets/vectorLeftTablet.svg"
        : "/assets/vectorLeft.svg";

  const rightVectorSrc = 
    deviceType === "mobile" 
      ? "/assets/vectorRightMobile.svg"
      : deviceType === "tablet"
        ? "/assets/vectorRightTablet.svg"
        : "/assets/vectorRight.svg";

  const leftVectorStyle = {
    mobile: { height: "15%", width: "15%" },
    tablet: { height: "20%", width: "15%" },
    desktop: { height: "69%", width: "11%" }
  };

  const rightVectorStyle = {
    mobile: { width: "15%" },
    tablet: { width: "38%" },
    desktop: { width: "18%" }
  };

  return (
    <section className="relative bg-primary-100 overflow-hidden">
      <img
        src={leftVectorSrc}
        alt=""
        className={`absolute bottom-0 left-0 rotate-[0deg] z-0 ${deviceType === "mobile" ? "block" : deviceType === "tablet" ? "block" : "hidden md:block"}`}
        style={leftVectorStyle[deviceType]}
      />

      <img
        src={rightVectorSrc}
        alt=""
        className={`absolute top-0 right-0 rotate-[0deg] z-0 ${deviceType === "mobile" ? "block" : deviceType === "tablet" ? "block" : "hidden md:block"}`}
        style={rightVectorStyle[deviceType]}
      />

      <div className="relative z-10 py-32 md:py-64 container mx-auto">
        {children}
      </div>
    </section>
  );
};
